module.exports = __webpack_public_path__ + "media/icons/pierwszy-wlasciciel@3x-14185fd5.svg";